import React, { useState } from "react";
import axios from "axios";
import Navbar from "../Navbar";
import Footer from "../Footer";
import Popup from "../Popup";
import { Link } from "react-router-dom";
import renderHTML from "react-render-html";
import kosodelnik from "../../images/kosodelnik.png";
import kosodelnikModry from "../../images/kosodelnik-modry.png";
import home1 from "../../images/home1.jpg";
import home2 from "../../images/home2.jpg";
import home3 from "../../images/home3.jpg";
import {
  WORDPRESS_URL,
  WP_POSTS_SLUG,
  WP_POSTS_CATEGORIES,
  WP_CATEGORIES_SLUG
} from "../../utils/constants";
import Preloader from "../Preloader";

class Homepage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        bodyPost: { idx: "", title: "", text: "", shortText: "", slug: "", date: "" },
        footerPost: { idx: "", title: "", text: "", shortText: "", slug: "", date: "" },
        aktualityCategory: { id: 0 },
        actualityPosts: [],
        actualityPost: { idx: "", title: "", text: "", shortText: "", slug: "", date: "" },
        index: 1,
        headerBgClass: "home",
        firstRectSrc: kosodelnikModry,
        secondRectSrc: kosodelnik, 
        nextHeaderBgIndex: 2,
        firstArticle: "",
        secondArticle: "hidden",
        whoWeAreImg: home1,
        whoWeAre: [home1, home2, home3],
        whoWeAreIndex: 1,
        showPopup: true,
        error: "",
        isLoading: true
    };

    this.actualityToggle = this.actualityToggle.bind(this);
    this.bgToggle = this.bgToggle.bind(this);
  }

  togglePopup = () => {
    this.setState({
      showPopup: !this.state.showPopup,
    });
  }

  actualityToggle(direction) {
    if (direction === "next") {
      if (this.state.index === this.state.actualityPosts.length) {
        this.setState({
          index: 1,
          actualityPost: this.state.actualityPosts[0]
        });
      } else {
        let idx = this.state.index + 1;
        this.setState({
          index: idx,
          actualityPost: this.state.actualityPosts[idx - 1]
        });
      }
    } else {
      if (this.state.index === 1) {
        let idx = this.state.actualityPosts.length;
        this.setState({
          index: idx,
          actualityPost: this.state.actualityPosts[idx - 1]
        });
      } else {
        let idx = this.state.index - 1;
        this.setState({
          index: idx,
          actualityPost: this.state.actualityPosts[idx - 1]
        });
      }
    }
  }

  whoWeAreToggle(direction) {
    if (direction === "next") {
      if (this.state.whoWeAreIndex === this.state.whoWeAre.length) {
        this.setState({
            whoWeAreIndex: 1,
            whoWeAreImg: this.state.whoWeAre[0]
        });
      } else {
        let idx = this.state.whoWeAreIndex + 1;
        this.setState({
            whoWeAreIndex: idx,
            whoWeAreImg: this.state.whoWeAre[idx - 1]
        });
      }
    } else {
      if (this.state.whoWeAreIndex === 1) {
        let idx = this.state.whoWeAre.length;
        this.setState({
            whoWeAreIndex: idx,
            whoWeAreImg: this.state.whoWeAre[idx - 1]
        });
      } else {
        let idx = this.state.whoWeAreIndex - 1;
        this.setState({
            whoWeAreIndex: idx,
            whoWeAreImg: this.state.whoWeAre[idx - 1]
        });
      }
    }
  }

  bgToggle(number) {
    if (number === 1) {
      this.setState({
          firstRectSrc: kosodelnikModry,
          secondRectSrc: kosodelnik,
          headerBgClass: "home",
          nextHeaderBgIndex: 2,
          firstArticle: "",
          secondArticle: "hidden"
      });
    } else {
        this.setState({
            firstRectSrc: kosodelnik,
            secondRectSrc: kosodelnikModry,
            headerBgClass: "recultivation",
            nextHeaderBgIndex: 1,
            firstArticle: "hidden",
            secondArticle: ""
        });
    }
  }

  componentDidMount() {
    if(!localStorage.POPUP || new Date(localStorage.POPUP) < new Date()){
        var date = new Date();
        date.setDate(date.getDate() + 1);
        localStorage.setItem("POPUP", date);
    }
    else{
        this.setState({showPopup:false});
    }

    const WHO_WE_ARE = "kdo-jsme";
    const LOOK_UP_DEEP = "nahlednete-do-nitra-zeme";
    const ACTUAL = "aktuality";

    axios
      .all([
        axios.get(WORDPRESS_URL + WP_POSTS_SLUG + WHO_WE_ARE),
        axios.get(WORDPRESS_URL + WP_POSTS_SLUG + LOOK_UP_DEEP),
        axios.get(WORDPRESS_URL + WP_CATEGORIES_SLUG + ACTUAL)
      ])
      .then(
        axios.spread((req1, req2, req3) => {
          this.setState({
            bodyPost: {
                idx: req1.data[0].id,
                title: req1.data[0].title.rendered,
                text: req1.data[0].content.rendered, 
                shortText: req1.data[0].excerpt.rendered,
                slug: req1.data[0].slug,
                date: req1.data[0].date
            },
            footerPost: {
                idx: req2.data[0].id,
                title: req2.data[0].title.rendered,
                text: req2.data[0].content.rendered, 
                shortText: req2.data[0].excerpt.rendered,
                slug: req2.data[0].slug,
                date: req2.data[0].date
            },
            aktualityCategory: req3.data[0]
          });

          axios
            .get(WORDPRESS_URL + WP_POSTS_CATEGORIES + req3.data[0].id)
            .then(res3 => {
              const actualityPosts = res3.data
                .slice(0, 4)
                .map(function(actuality, idx) {
                    return {
                        idx: actuality.id,
                        title: actuality.title.rendered,
                        text: actuality.content.rendered, 
                        shortText: actuality.excerpt.rendered,
                        slug: actuality.slug,
                        date: actuality.date
                    };
                });

              this.setState({
                actualityPosts: actualityPosts,
                actualityPost: actualityPosts[0] ? actualityPosts[0] : { idx: "", title: "", text: "", shortText: "", slug: "", date: "" },
                isLoading: false
              });
            });
        })
      );

      this.interval = setInterval(() => this.bgToggle(this.state.nextHeaderBgIndex), 14000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

renderHeader = () => {
    return(
        <header className={this.state.headerBgClass}>
            <Navbar />
            
            <div className="sd-container">
                <section id="sub-header">
                <div className="row">
                    <div className="col-md-7 col-xl-8 ">
                    <div className="d-flex justify-content-between align-items-center">
                        <h6 className="sub-header-sub-caption text-uppercase">
                        Severočeské doly
                        </h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <h6 className="sub-header-caption text-uppercase">
                        Těžíme
                        <br />
                        zodpovědně
                        </h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="sub-header-chevrons">
                        <img
                            src={this.state.firstRectSrc}
                            alt="chevron_white"
                            className="first header-toogle-button"
                            onClick={() => this.bgToggle(1)}
                        />
                        <img
                            src={this.state.secondRectSrc}
                            alt="chevron_sd"
                            className="second header-toogle-button"
                            onClick={() => this.bgToggle(2)}
                        />
                        </span>
                    </div>
                    </div>
                    <div className={"col-md-5 col-xl-4 " + this.state.firstArticle}>
                    <div className="d-flex justify-content-between align-items-center sd-mt-4">
                        <h6 className="sub-header-sub-caption text-uppercase sd-hidden-xs">
                        Těžíme
                        </h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <p className="sub-header-text">
                        V souladu s vizí efektivní a bezpečné těžby zajišťujeme
                        spolehlivé dodávky pro naše zákazníky, klademe důraz na
                        investice a inovativní přístup. Přitom věnujeme
                        mimořádnou pozornost bezpečnosti práce a ochraně zdraví.
                        </p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                    <Link
                        to={"/tezime-kvalitni-uhli"}
                        className="who-we-are-more-btn-link"
                        >
                        <div className="sub-header-more-btn d-flex justify-content-between align-items-center">
                        <span className="btn-text text-white text-uppercase pl-4">
                            Zjistit více{" "}
                            <i className="fa fa-chevron-right ml-2"></i>
                        </span>
                        </div>
                        </Link>
                    </div>
                    </div>

                    <div className={"col-md-5 col-xl-4 " + this.state.secondArticle}>
                    <div className="d-flex justify-content-between align-items-center sd-mt-4">
                        <h6 className="sub-header-sub-caption text-uppercase sd-hidden-xs">
                        Rekultivujeme
                        </h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <p className="sub-header-text">
                        Měníme krajinu pro lepší život náš i budoucích generací tam, 
                        kde dříve probíhala povrchová těžba uhlí. 
                        Terén se rekultivacemi postupně mění na lokalitu s vodními díly a rozmanitou přírodou.
                        </p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                    <Link
                        to={"/rekultivujeme"}
                        className="who-we-are-more-btn-link"
                        >
                        <div className="sub-header-more-btn d-flex justify-content-between align-items-center">
                        <span className="btn-text text-white text-uppercase pl-4">
                            Zjistit více{" "}
                            <i className="fa fa-chevron-right ml-2"></i>
                        </span>
                        </div>
                        </Link>
                    </div> 
                    </div>
                </div>
                </section>
            </div>
        </header>
    );
}

renderMainContainer = () => {
    const { bodyPost, whoWeAreImg, whoWeAreIndex, whoWeAre } = this.state;
    return(
        <section id="main-container">
            <div className="sd-container">
                <section id="pictured-navigation">
                <div className="row justify-content-center">
                    <Link
                        to={"/tezime-kvalitni-uhli"}
                        className="col-sm-12 col-md-3 no-padding tile-link"
                    >
                        <div className="o-padding pic-nav first-pic-nav justify-content-center align-items-center d-flex">
                            <span className="btn-text text-uppercase pic-nav-padding text-center">
                                Těžíme kvalitní uhlí
                            </span>
                        </div>
                    </Link>
                    <Link
                        to={"/rekultivujeme"}
                        className="col-sm-12 col-md-3 no-padding tile-link"
                    >
                        <div className="no-padding pic-nav second-pic-nav justify-content-center align-items-center d-flex">
                            <span className="btn-text text-uppercase pic-nav-padding text-center">
                                Rekultivujeme krajinu
                            </span>
                        </div>
                    </Link>
                    <Link
                        to={"/pomahame"}
                        className="col-sm-12 col-md-3 no-padding tile-link"
                    >
                        <div className="no-padding pic-nav third-pic-nav justify-content-center align-items-center d-flex">
                            <span className="btn-text text-uppercase pic-nav-padding text-center">
                                Pomáháme okolí
                            </span>
                        </div>
                    </Link>
                    <Link
                        to={"/chranime-prirodu"}
                        className="col-sm-12 col-md-3 no-padding tile-link"
                    >
                        <div className="no-padding pic-nav fourth-pic-nav justify-content-center align-items-center d-flex">
                            <span className="btn-text text-uppercase pic-nav-padding text-center">
                                Chráníme přírodu
                            </span>
                        </div>
                    </Link>
                </div>
                </section>

                <section id="who-we-are">
                <div className="row">
                    <div className="col-md-6">
                    <div className="d-flex justify-content-center align-items-center who-we-are" style={{backgroundImage:`url("${whoWeAreImg}")`}}>
                        <div className="who-we-are-paging">
                        <div className="col-4 h-100 no-padding d-flex justify-content-center align-items-center link" onClick={() => this.whoWeAreToggle("back")}>
                            <i className="fa fa-chevron-left"></i>
                        </div>
                        <div className="col-4 h-100 no-padding d-flex justify-content-center align-items-center">
                            {whoWeAreIndex}/{whoWeAre.length}
                        </div>
                        <div className="col-4 h-100 no-padding d-flex justify-content-center align-items-center link" onClick={() => this.whoWeAreToggle("next")}>
                            <i className="fa fa-chevron-right"></i>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div className="col-md-6 p-0-50">
                    <div className="d-flex justify-content-between align-items-center mt-4-v2">
                        <h6 className="who-we-are-sub-caption text-uppercase">
                        Zjistěte
                        </h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <h2 className="who-we-are-caption text-uppercase">
                        {bodyPost.title}
                        </h2>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="who-we-are-text">
                        {renderHTML(bodyPost.text)}
                        </div>
                    </div>
                    <div className="row who-we-are-gallery mb-4">
                        <div className="col-4 p-1">
                        <a href={home1}><img src={home1} alt="thumbnail-galerie-clanek" /></a>
                        </div>
                        <div className="col-4 p-1">
                        <a href={home2}><img src={home2} alt="thumbnail-galerie-clanek" /></a>
                        </div>
                        <div className="col-4 p-1">
                        <a href={home3}><img src={home3} alt="thumbnail-galerie-clanek" /></a>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <Link
                        to={"/o-spolecnosti"}
                        className="who-we-are-more-btn-link"
                        >
                        <div className="who-we-are-more-btn text-white d-flex align-items-center">
                            <span className="btn-text text-uppercase">
                            Více o nás{" "}
                            <i className="fa fa-chevron-right ml-2"></i>
                            </span>
                        </div>
                        </Link>
                    </div>
                    </div>
                </div>
                </section>
            </div>
        </section>
    );
}

renderSecondaryContainer = () => {
    return(
        <section id="secondary-container"></section>
    );
}

renderActualMobileDevice = () => {
    const { actualityPost, actualityPosts, index } = this.state;

    return(
        <section id="actual-xs">
            <div className="row m-0">
                <div className="col actual p-50">
                <div className="d-flex justify-content-between align-items-center mt-4-v2">
                    <h6 className="actual-into-deep-caption text-uppercase">
                    <a href="/aktuality" className="text-white link">Aktuality</a>
                    </h6>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                    <h2 className="actual-into-deep-subcaption text-uppercase">
                    {actualityPost.title}
                    </h2>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="actual-into-deep-text">
                    {renderHTML(actualityPost.shortText)}
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-2">
                    <Link
                    to={`clanek/${actualityPost.slug}`}
                    className="who-we-are-more-btn-link"
                    >
                    <div className="actual-more-btn link text-white">
                        <span className="btn-text text-uppercase">
                        Zjistit více <i className="fa fa-chevron-right ml-2"></i>
                        </span>
                    </div>
                    </Link>
                </div>
                </div>
            </div>
            <div className="row m-0">
                <div className="col p-0">
                <div className="actual-paging">
                    <div
                    className="col-4 h-100 no-padding d-flex justify-content-center align-items-center link"
                    onClick={() => this.actualityToggle("back")}
                    >
                    <i className="fa fa-chevron-left"></i>
                    </div>
                    <div className="col-4 h-100 no-padding d-flex justify-content-center align-items-center">
                    {index}/{actualityPosts.length}
                    </div>
                    <div
                    className="col-4 h-100 no-padding d-flex justify-content-center align-items-center link"
                    onClick={() => this.actualityToggle("next")}
                    >
                    <i className="fa fa-chevron-right"></i>
                    </div>
                </div>
                </div>
            </div>
        </section>
    );
}

renderFooter = () => {
    const { actualityPost, actualityPosts, index, footerPost } = this.state;

    return(
        <footer>
            <div className="sd-container">
                <section id="actual-into-deep">
                    <div className="row m-0">
                        <div className="col-md-6 p-50 actual sd-hidden-xs">
                        <div className="d-flex justify-content-between align-items-center mt-4-v2">
                            <h6 className="actual-into-deep-caption text-uppercase">
                            <a href="/aktuality" className="text-white link">Aktuality</a>
                            </h6>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                            <h2 className="actual-into-deep-subcaption text-uppercase">
                            {actualityPost.title}
                            </h2>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="actual-into-deep-text">
                            {renderHTML(actualityPost.shortText)}
                            </div>
                        </div>
                        <div className="actual-paging">
                            <div
                            className="col-4 h-100 no-padding d-flex justify-content-center align-items-center link"
                            onClick={() => this.actualityToggle("back")}
                            >
                            <i className="fa fa-chevron-left"></i>
                            </div>
                            <div className="col-4 h-100 no-padding d-flex justify-content-center align-items-center">
                            {index}/{actualityPosts.length}
                            </div>
                            <div
                            className="col-4 h-100 no-padding d-flex justify-content-center align-items-center link"
                            onClick={() => this.actualityToggle("next")}
                            >
                            <i className="fa fa-chevron-right"></i>
                            </div>
                        </div>
                        <Link
                            to={`clanek/${actualityPost.slug}`}
                            className="who-we-are-more-btn-link"
                        >
                            <div className="actual-more-btn link text-white">
                            <span className="btn-text text-uppercase">
                                Zjistit více{" "}
                                <i className="fa fa-chevron-right ml-2"></i>
                            </span>
                            </div>
                        </Link>
                        </div>
                        <div className="col-md-6 p-50 into-deep">
                        <div className="d-flex justify-content-between align-items-center mt-4-v2">
                            <h6 className="actual-into-deep-caption text-uppercase">
                            Prohlídka provozu
                            </h6>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                            <h2 className="actual-into-deep-subcaption text-uppercase">
                            {footerPost.title}
                            </h2>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="actual-into-deep-text">
                            {renderHTML(footerPost.text)}
                            </div>
                        </div>
                        <a
                            href={'https://www.sdas.cz/prohlidkaprovozu/'}
                            className="who-we-are-more-btn-link"
                        >
                            <div className="into-deep-more-btn link  text-white ">
                            <span className="btn-text text-uppercase">
                                Vstupte <i className="fa fa-chevron-right ml-2"></i>
                            </span>
                            </div>
                        </a>
                        </div>
                    </div>
                </section>

                <section id="footer-content" className="footer-top-padding">
                    <Footer />
                </section>
            </div>
        </footer>            
    );
}

render() {
    const { isLoading } = this.state; 
    //const isLoading  = true; 

    return (  
        <section id="web">
            <div id="preload">
                {/* <img src={require('../../images/header-bg.jpg')}></img> */}
            </div>

            {isLoading ? (
                <Preloader isLoaded={!isLoading} />
            ) : ( 
                <div className="wrapper">
                    {this.renderHeader()}

                    {this.renderMainContainer()}

                    {this.renderSecondaryContainer()}

                    {this.renderActualMobileDevice()}

                    {this.renderFooter()}

                    {this.state.showPopup ?
                        <Popup closePopup={() => this.togglePopup()} />
                        : null
                    }
                </div>
            )}
        </section>
    );
  }
}

export default Homepage;